<template lang="pug">
.campaign(style="position: relative")
  .campaign__header
    el-breadcrumb(
      separator="/"
      style="font-size: 14px"
    )
      el-breadcrumb-item(
        v-if="isVendor"
        :to="{ path: '/vendor-campaign/list' }"
      ) {{ $t('项目列表') }}
      el-breadcrumb-item(
        v-else
        :to="{ path: '/campaign/list' }"
      ) {{ $t('项目列表') }}

      el-breadcrumb-item(:to="{ path: processName }") {{ campaignName }}
      el-breadcrumb-item(v-if="!hideTaskBreadCrumb") {{ $t(taskName) }}
    span(@click="$router.push(hideTaskBreadCrumb ? (isVendor ? '/vendor-campaign/list' : '/campaign/list') : processName)") < {{ $t('返回') }}
  campaign-survey(:id="campaignId")
  block-tabs(
    v-if="TABS && isShowTab"
    :tabs="TABS.map(i => i.name)"
    :index="tabIndex"
    @change="changeTab"
  )
  el-card.campaign__flow-container
    router-view(@updateTab="getTabs")
</template>

<script>
import CampaignSurvey from '@/components/CampaignSurvey'
import BlockTabs from '@/components/BlockTabs'
import axios from 'axios'

export default {
  components: {
    CampaignSurvey,
    BlockTabs
  },
  data () {
    return {
      subFinalScopeId: null,
      activeName: 'first',
      TABS: null
    }
  },
  computed: {
    isVendor () {
      return this.$store.state.common.user.is_vendor
    },
    tabIndex () {
      return this.TABS.indexOf(this.TABS.find(tab => tab.activePath.includes(this.$route.path)))
    },
    isShowTab () {
      // 某几个页面才显示tab
      return [
        '/campaign/process',
        '/campaign/participants',
        '/campaign/dot',
        '/campaign/dot/social-tracking',
        '/campaign/shortcut',
        '/vendor-campaign/process'
      ].includes(this.$route.path)
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    campaignName () {
      return this.$store.state.campaign.campaignName
    },
    taskName () {
      return this.$store.state.campaign.taskName
    },
    hideTaskBreadCrumb () {
      const regex = RegExp('/campaign/process|/campaign/participants|/vendor-campaign/process|/vendor-campaign/process|/campaign/dot')
      return regex.test(this.$route.path)
    },
    processName () {
      return this.isVendor ? '/vendor-campaign/process' : '/campaign/process'
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    },
    hasSubFinalScope () {
      return this.phaseType !== 1 && this.phaseType !== 2 && this.phaseType !== 5
    }
  },
  mounted () {
    this.getTabs()
  },
  methods: {
    changeTab (index) {
      this.$router.push(this.TABS[index].routePath)
    },
    getDotInfo () {
      return axios
        .get('/management/subfinal/getDotProcess', {
          params: {
            campaign_id: this.campaignId
          }
        })
    },
    canViewProcess () {
      return axios
        .get('/management/subfinal/canViewProcess', {
          params: {
            campaign_id: this.campaignId
          }
        })
    },
    async getTabs () {
      let tabs = []
      if (!this.hasSubFinalScope) {
        tabs.push({
          name: '流程',
          routePath: this.isVendor ? '/vendor-campaign/process' : '/campaign/process',
          activePath: [
            '/vendor-campaign/process',
            '/campaign/process'
          ]
        })
      } else {
        const res = await this.canViewProcess()
        if (res.can_view) {
          tabs.push({
            name: '流程',
            routePath: this.isVendor ? '/vendor-campaign/process' : '/campaign/process',
            activePath: [
              '/vendor-campaign/process',
              '/campaign/process'
            ]
          })
        }
      }

      if (this.hasSubFinalScope && !this.isVendor) {
        const res = await this.getDotInfo()
        if (res.need_dot) {
          tabs.push({
            name: 'DOT流程',
            routePath: '/campaign/dot',
            activePath: [
              '/campaign/dot/social-tracking'
            ]
          })
          this.$store.commit('campaign/setDotSubFinalScopeId', res.sub_final_scope_id)
          this.$store.commit('campaign/setDotPhaseType', res.phase_type)
          this.$store.commit('campaign/setDotBusinessType', res.business_type)
        }
      }
      if (!this.isVendor) {
        tabs.push({
          name: '参与人员',
          routePath: '/campaign/participants',
          activePath: [
            '/campaign/participants'
          ]
        })
      }
      this.TABS = tabs
    }
  }
}
</script>

<style lang="stylus">
.campaign
  height 100%
  display flex
  flex-direction column
  > .el-card
    flex 1
    > .el-card__body
      padding 16px 32px !important

.campaign__header
  display flex
  justify-content space-between
  align-items center
  font-size 12px
  > span
    color $main
    cursor pointer
</style>
